module.exports = __webpack_public_path__ + "img/tooltip.db63a96f.svg";